export default {
  subtotal: 'Välisumma',
  tip: 'Tippi',
  discount: 'Alennus',
  method_fee: 'Toimitusmaksu',
  service_fee: {
    title: 'Palvelumaksu',
    description:
      'Tämä pieni palvelumaksu auttaa meitä kattamaan kuluja, jotka liittyvät jokaiseen tilaukseen — kuten tekstiviestipäivitysten lähettäminen tilauksestasi, verkkotilausalustamme ylläpito ja mahdolliset lisätransaktiokulut. Älä huoli — tämä maksu on silti paljon pienempi kuin mitä maksaisit toimitussovelluksissa. Kiitos ymmärryksestäsi ja siitä, että tuet meitä suoraan. Arvostamme sinua!',
  },
  payment_method_upcharge_fee: {
    title: 'PayPal-maksu',
    description:
      'Joka kerta kun asiakas maksaa PayPalilla, PayPal veloittaa 6-7 % maksun. Joten 100 eurosta menetämme 6-7 €. Siksi joudumme valitettavasti lisäämään 3,5 %:n lisämaksun PayPalin käytöstä. 🤯 Harkitse jonkin muun turvallisen ja salatun maksutavan käyttöä kassalla. Olemme hyvin kiitollisia ymmärryksestäsi ja tuestasi! 🙏',
  },
  tax: 'Verot',
  total: 'Yhteensä',
  earned_points: 'Ansaitsit {{points}} pistettä',
};
